module.exports = __webpack_public_path__ + "static/img/tip1.45e1225.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/tip1.png
// module id = lElk
// module chunks = 1